import { useState, useRef } from "react";

export const useColumnsChart = (title, titleY) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            type: "column",
            zoomType: "xy",
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
            scrollablePlotArea: {
                minWidth: 700,
                scrollPositionX: 1,
            },
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        title: {
            text: title,
            align: "left",
        },
        xAxis: {
            title: { text: "" },
            categories: [],
            crosshair: true,
            min: 0,
        },
        legend: {
            enabled: false,
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            title: {
                text: titleY,
                skew3d: true,
                style: {
                    fontSize: "16px",
                },
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [],
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
